import React, { useState } from "react";
import { ListSubheader, Box, Typography, Button, Menu, MenuItem, ListItemText } from "@mui/material";
import { useRecoilState } from "recoil";

import { TreeStat } from "api/types";
// Services
// import Storage from "services/Storage";
import {
  // Seasons,
  treesQueryVarState,
  // FilterOptions,
  SortText,
  SortTypes,
  // SeasonTypes,
} from "state/atoms";
// import { generateYearArray } from "utils/date";

import {
  StyledListHeader,
  StyledListHeaderText,
  // StyledMenuDaysPaper,
  // StyledMenuDays,
  // StyledMenuDaysInput,
} from "./HomePage.styles";

// const FilterText: Record<FilterOptions, string> = {
//   INTIME: "In time",
//   DELAYED: "Delay",
//   ALL: "All",
// };

type HomeListSubHeaderProps = {
  treeStats?: TreeStat[];
};

type SetAnchor = (evt: React.MouseEvent<HTMLButtonElement>) => void;
type SetAnchorClose = () => void;
type UseAnchorElResponse = [HTMLElement | null, SetAnchor, SetAnchorClose];

const useAnchorEl = (): UseAnchorElResponse => {
  const [anchor, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  function handleClose() {
    setAnchorEl(null);
  }
  return [anchor, handleOpen, handleClose];
};

const HomeListSubHeader: React.FC<HomeListSubHeaderProps> = ({ treeStats }) => {
  const [variables, setVariables] = useRecoilState(treesQueryVarState);
  // const [anchorSeason, openSeasonMenu, handleCloseSeasonMenu] = useAnchorEl();
  const [anchorStats, openStatsMenu, handleCloseStatsMenu] = useAnchorEl();
  // const [anchorYear, openYearMenu, handleCloseYearMenu] = useAnchorEl();
  const [anchorSort, openSortMenu, handleCloseSortMenu] = useAnchorEl();
  // const [anchorFilter, openFilterMenu, handleCloseFilterMenu] = useAnchorEl();
  // const [anchorDays, openDaysMenu, handleCloseDaysMenu] = useAnchorEl();
  // const [daysDelayedLocal, setDaysDelayed] = useState(21);

  // const yearOptions = generateYearArray();

  // useEffect(() => {
  //   const days = Storage.getDaysDelayed();
  //   setDaysDelayed(days);
  // }, []);

  // function onSubmitDaysDelayed() {
  //   setVariables((p) => ({ ...p, daysDelayed: daysDelayedLocal }));
  //   Storage.setDaysDelayed(daysDelayedLocal);
  //   handleCloseDaysMenu();
  // }

  // function handleSliderChange(_: any, newValue: number | number[]) {
  //   if (typeof newValue === "number") {
  //     setDaysDelayed(newValue);
  //   }
  // }

  // function handleInputBlur() {
  //   if (daysDelayedLocal < 5) {
  //     setDaysDelayed(5);
  //   } else if (daysDelayedLocal > 50) {
  //     setDaysDelayed(50);
  //   }
  // }

  // function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
  //   setDaysDelayed(Number(event.target.value));
  // }

  function handlePickSort(sort: SortTypes) {
    setVariables((p) => ({ ...p, orderBy: sort }));
    handleCloseSortMenu();
  }

  // function handlePickYearSort(year: string) {
  //   setVariables((p) => ({ ...p, year }));
  //   handleCloseYearMenu();
  // }

  // function handlePickFilter(filter: FilterOptions) {
  //   setVariables((p) => ({ ...p, filterBy: filter }));
  //   handleCloseFilterMenu();
  // }

  // function handlePickSeason(season: SeasonTypes) {
  //   setVariables((p) => ({ ...p, season }));
  //   handleCloseSeasonMenu();
  // }

  const {
    orderBy,
    // year,
    // season,
  } = variables;

  // const seasonText = Seasons[season] ?? Seasons.ALL;

  return (
    <ListSubheader component={StyledListHeader} disableSticky>
      {treeStats?.length ? (
        <Box display="flex" alignItems="center" mr="auto">
          <Button onClick={openStatsMenu}>Tree Stats</Button>
          <Menu anchorEl={anchorStats} keepMounted open={Boolean(anchorStats)} onClose={handleCloseStatsMenu}>
            {treeStats.map(({ count, year }) => {
              return (
                <MenuItem key={year}>
                  <Typography>
                    Year: {year} Count: {count}
                  </Typography>
                </MenuItem>
              );
            })}
          </Menu>
        </Box>
      ) : null}
      {/* <Box display="flex" alignItems="center">
        <Typography component={StyledListHeaderText}>Season:</Typography>
        <Button onClick={openSeasonMenu}>{seasonText}</Button>
        <Menu anchorEl={anchorSeason} keepMounted open={Boolean(anchorSeason)} onClose={handleCloseSeasonMenu}>
          {Object.entries(Seasons).map(([key, value]) => {
            return (
              <MenuItem key={key} onClick={() => handlePickSeason(key as SeasonTypes)}>
                <Typography>{value}</Typography>
              </MenuItem>
            );
          })}
        </Menu>
      </Box> */}

      {/* <Box display="flex" alignItems="center">
        <Typography component={StyledListHeaderText}>Created at:</Typography>
        <Button onClick={openYearMenu}>{year}</Button>
        <Menu anchorEl={anchorYear} keepMounted open={Boolean(anchorYear)} onClose={handleCloseYearMenu}>
          <MenuItem onClick={() => handlePickYearSort("ALL")}>
            <ListItemText primary={"All"} />
          </MenuItem>
          {yearOptions.map((year) => {
            return (
              <MenuItem key={year} onClick={() => handlePickYearSort(year)}>
                <ListItemText primary={year} />
              </MenuItem>
            );
          })}
        </Menu>
      </Box> */}
      <Box display="flex" alignItems="center">
        <Typography component={StyledListHeaderText}>Order by:</Typography>
        <Button onClick={openSortMenu}>{SortText[orderBy]}</Button>
        <Menu anchorEl={anchorSort} keepMounted open={Boolean(anchorSort)} onClose={handleCloseSortMenu}>
          {Object.entries(SortText).map(([key, value]) => (
            <MenuItem key={key} onClick={() => handlePickSort(key as SortTypes)}>
              <ListItemText primary={value} />
            </MenuItem>
          ))}
        </Menu>
      </Box>
      {/* <Box display="flex" alignItems="center">
        <Typography component={StyledListHeaderText}>Filter by:</Typography>
        <Button onClick={openFilterMenu}>{FilterText[variables.filterBy]}</Button>
        <Menu anchorEl={anchorFilter} keepMounted open={Boolean(anchorFilter)} onClose={handleCloseFilterMenu}>
          <MenuItem onClick={() => handlePickFilter("DELAYED")}>Delayed</MenuItem>
          <MenuItem onClick={() => handlePickFilter("ALL")}>All</MenuItem>
        </Menu>
      </Box> */}
      {/* {variables.filterBy === "DELAYED" && (
        <Box display="flex" alignItems="center">
          <Typography component={StyledListHeaderText}>Days Delayed:</Typography>
          <Button onClick={openDaysMenu}>{daysDelayedLocal}</Button>
          <Menu
            anchorEl={anchorDays}
            keepMounted
            open={Boolean(anchorDays)}
            onClose={handleCloseDaysMenu}
            slots={{
              paper: StyledMenuDaysPaper,
              root: StyledMenuDays,
            }}
          >
            <Box alignItems="center" display="flex" px={2} py={1}>
              <Box flex={1}>
                <Slider value={daysDelayedLocal} min={5} max={50} onChange={handleSliderChange} />
              </Box>
              <StyledMenuDaysInput
                value={daysDelayedLocal}
                margin="dense"
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                inputProps={{
                  step: 1,
                  min: 0,
                  max: 50,
                  type: "number",
                  "aria-labelledby": "input-slider",
                }}
              />
              <Button variant="contained" color="primary" onClick={onSubmitDaysDelayed}>
                OK
              </Button>
            </Box>
          </Menu>
        </Box>
      )} */}
    </ListSubheader>
  );
};

export default HomeListSubHeader;
